export default "__VITE_ASSET__CckDpFNV__"